export default __webpack_public_path__ + "static/media/esg-summit-updapt-llc-2024.8b5c0f98.jpg";